<div *ngIf="showMe">
    <tds-modal show="true" (tdsClose)="closeDialog()" header="Action needed" size="md">
        <span slot="body">
            <h3>Expired Assignments</h3>
            <p style="text-align: justify;">One or more assignments has been ongoing for more then one year since it was started,
            or since it was extended. Expired assignments should be assigned an end date or be extended.
            Please take action. Click on "Expired Only" in the menu to see all expired assignments.
            </p>
        </span>

        <span slot="actions">
            <tds-button
                data-dismiss-modal
                type="button"
                variant="primary"
                size="md"
                text="Close">
            </tds-button>
        </span>
    </tds-modal>
</div>